import { CSSProperties } from 'react';
import { Alert, Box } from '@mui/material';
import {
	InfoOutlined as InfoOutlinedIcon,
	TaskAlt as TaskAltIcon,
	ErrorOutline as ErrorOutlinedIcon,
	WarningAmber as WarningAmberIcon
} from '@mui/icons-material';

interface AlertBigProps {
	severity?: 'error' | 'info' | 'success' | 'warning';
	children: React.ReactNode;
	title?: React.ReactNode;
	sx?: CSSProperties;
}

function AlertBig({ severity = 'info', children, title, sx }: AlertBigProps) {
	let icon;

	switch (severity) {
		case 'info':
			icon = <InfoOutlinedIcon style={{ fontSize: 40, marginLeft: '15px' }} />;
			break;

		case 'success':
			icon = <TaskAltIcon style={{ fontSize: 40, marginLeft: '15px' }} />;
			break;

		case 'error':
			icon = <ErrorOutlinedIcon style={{ fontSize: 40, marginLeft: '15px' }} />;
			break;

		case 'warning':
			icon = <WarningAmberIcon style={{ fontSize: 40, marginLeft: '15px' }} />;
			break;
	}

	return (
		<Alert
			severity={severity}
			icon={icon}
		>
			<Box sx={{ padding: '20px' }}>
				{title ? <Box sx={{ fontSize: '25px', fontWeight: 'bold', marginBottom: '10px' }}>{title}</Box> : null}
				<Box>
					{children}
				</Box>
			</Box>
		</Alert>
	);
}

export default AlertBig;